module.exports = __webpack_public_path__ + "static/户外EMC证书-7d9375031e161b57c8f23505682f866c.jpg";